import { FormControlLabel, Checkbox, FormHelperText, Grid } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import React, { useCallback } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { ReactQueryKey } from "../../../../../types";
import { isLeisureCode, stepState } from "../../../recoil";
import { IFormValues, InsertBookingStep } from "../../../types";

export const FormDiscountType = () => {

    const { t } = useTranslation('booking');

    const step = useRecoilValue(stepState);
    const flagLeisureCode = useRecoilValue(isLeisureCode);

    const formContext = useFormContext<IFormValues>();
    const discountType = useWatch<IFormValues, 'extraServices.discountType'>({
        name: 'extraServices.discountType'
    });

    const queryClient = useQueryClient();

    const handleChange = useCallback((checked: boolean, value: 'promo' | 'fca') => {
        formContext.setValue(
            'extraServices.discountType',
            checked ? value : null
        );
        formContext.resetField('extraServices.discountCode');
        formContext.resetField('extraServices.fcaBankCardNumber');
        queryClient.resetQueries([ReactQueryKey.Coupon, {
            tenant: formContext.getValues('basicDetails.tenants') as string,
            dealer: formContext.getValues('basicDetails.dealers') as string
        }]);
    }, []);

    return (
        <>
            <Grid container>
                <Grid item md={6} xs={6}>
                    <FormControlLabel
                        label={t('label.promo')}
                        disabled={step === InsertBookingStep.CUSTOMER_DETAILS || flagLeisureCode}
                        sx={{
                            mt: 2
                        }}
                        control={
                            <Checkbox
                                checked={discountType === 'promo'}
                                onChange={(e, checked) => {
                                    handleChange(checked, 'promo');
                                }}
                            />
                        }
                    />
                    {formContext.control.getFieldState('extraServices.discountType')?.error &&
                        discountType === 'promo' &&
                        <FormHelperText error>
                            {t((formContext.control.getFieldState('extraServices.discountType').error?.message) as string)}
                        </FormHelperText>
                    }
                </Grid>
                <Grid item md={6} xs={6}>
                    <FormControlLabel
                        label={t('label.fcaBank')}
                        disabled={step === InsertBookingStep.CUSTOMER_DETAILS || flagLeisureCode}
                        sx={{
                            mt: 2
                        }}
                        control={
                            <Checkbox
                                checked={discountType === 'fca'}
                                onChange={(e, checked) => {
                                    handleChange(checked, 'fca');
                                }}
                            />
                        }
                    />
                    {formContext.control.getFieldState('extraServices.discountType')?.error &&
                    discountType === 'fca' &&
                    <FormHelperText error>
                        {t((formContext.control.getFieldState('extraServices.discountType').error?.message) as string)}
                    </FormHelperText>
                    }
                </Grid>
            </Grid>
        </>
    );
};

export default FormDiscountType;
